import { Directive, Inject, Input } from '@angular/core';
import {
  AsyncValidator,
  AbstractControl,
  ValidationErrors,
  Validators,
  NG_ASYNC_VALIDATORS
} from '@angular/forms';
import { Observable, of } from 'rxjs';
import {
  VALIDATORS_CONFIGURATION_TOKEN,
  ValidatorsConfiguration
} from '../tokens';
import { CommonService } from '@ecosure-suite/shared/utils-helpers';

@Directive({
  selector:
    // tslint:disable-next-line: directive-selector
    '[idNumber][formControlName],[idNumber][formControl],[idNumber][ngModel]',
  providers: [
    {
      provide: NG_ASYNC_VALIDATORS,
      useExisting: IdNumberValidatorDirective,
      multi: true
    }
  ]
})
export class IdNumberValidatorDirective implements AsyncValidator {
  @Input() required: boolean = undefined;
  @Input() enabled: boolean = undefined;

  idNumberValidator: { enabled: boolean; required: boolean; regex: string };

  constructor(
    @Inject(VALIDATORS_CONFIGURATION_TOKEN)
    configuration: ValidatorsConfiguration
  ) {
    this.idNumberValidator = configuration.idNumber;
  }

  validate(
    control: AbstractControl
  ): Promise<ValidationErrors> | Observable<ValidationErrors> {
    if (this.required === undefined || this.required === null) {
      if (this.idNumberValidator.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    } else {
      if (this.required) {
        const isRequired = Validators.required(control);
        if (CommonService.isDefined(isRequired)) {
          return of(isRequired);
        }
      }
    }

    if (this.enabled === undefined || this.enabled === null) {
      if (this.idNumberValidator.enabled) {
        return control.value.match(new RegExp(this.idNumberValidator.regex))
          ? of(null)
          : of({ idNumber: true });
      }
    } else {
      if (this.enabled) {
        return control.value.match(new RegExp(this.idNumberValidator.regex))
          ? of(null)
          : of({ idNumber: true });
      }
    }

    return of(null);
  }
}
